import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App.js';
import './i18n';

// Deprecated in react 18
//var mountNode = document.getElementById('root');
//ReactDOM.render(<App />, mountNode);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
